<template>
  <v-list-item @click="$emit('click')">
    <v-list-item-content>
      <v-list-item-title
        class="d-flex mx-0 px-0 blue-grey--text text--darken-3 mb-2 font-size-13"
      >
        <text-highlight
          data-private
          highlightClass="yellow lighten-1"
          highlightComponent="span"
          :queries="highlights"
          :title="team.name"
        >
          {{ team.name }}
        </text-highlight>
      </v-list-item-title>

      <v-list-item-subtitle
        class="font-size-12 blue-grey--text d-flex align-center"
      >
        <v-icon class="me-1" color="blue-grey" size="12">{{
          team.site ? 'mdi-warehouse' : 'mdi-earth'
        }}</v-icon>
        {{ subtitle }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TeamItem',

  props: {
    team: { type: Object, required: true },
    searchTerm: { type: String, default: '' },
  },

  computed: {
    ...mapGetters(['organizationSites']),

    sitesMap() {
      return new Map(this.organizationSites.map(site => [site.id, site]))
    },

    highlights() {
      return this.searchTerm ? [this.searchTerm] : []
    },

    subtitle() {
      return this.team.site
        ? this.sitesMap.get(this.team.site)?.name ?? this.team.site ?? ''
        : this.$t('common.global')
    },
  },
}
</script>
